"use strict";

/* =========================
   CONFIG
========================= */

const CONFIG = Object.freeze({
  currency: "$",
  maxTextLength: 20,
  maxUploadMB: 10,
  debounceDelay: 100
});

/* =========================
   CENTRAL VARIANT DATABASE
========================= */

const variantDatabase = Object.freeze({

  baseVariants: {

    rectangle: {

      birch: {

        "18x6":   { variantId: 51107210133737, price: 45.00 },
        "18x12":  { variantId: 51107210166505, price: 52.00 },
        "18x18":  { variantId: 51107210199273, price: 59.00 },

        "24x12":  { variantId: 51107210232041, price: 54.80 },
        "24x18":  { variantId: 51107210264809, price: 63.00 },
        "24x24":  { variantId: 51107210297577, price: 72.00 },

        "30x18":  { variantId: 51107210330345, price: 66.00 },
        "30x24":  { variantId: 51107210363113, price: 75.00 },
        "30x30":  { variantId: 51107210395881, price: 84.00 },

        "36x24":  { variantId: 51107210428649, price: 83.05 },
        "36x30":  { variantId: 51107210461417, price: 94.00 },
        "36x36":  { variantId: 51107210494185, price: 105.00 }

      },

      premium: {

        "18x6":   { variantId: 51107210526953, price: 58.56 },
        "18x12":  { variantId: 51107210559721, price: 65.56 },
        "18x18":  { variantId: 51107210592489, price: 72.56 },

        "24x12":  { variantId: 51107210625257, price: 68.36 },
        "24x18":  { variantId: 51107210658025, price: 79.20 },
        "24x24":  { variantId: 51107210690793, price: 88.20 },

        "30x18":  { variantId: 51107210723561, price: 85.80 },
        "30x24":  { variantId: 51107210756329, price: 94.80 },
        "30x30":  { variantId: 51107210789097, price: 103.80 },

        "36x24":  { variantId: 51107210821865, price: 113.56 },
        "36x30":  { variantId: 51107210854633, price: 124.90 },
        "36x36":  { variantId: 51107210887401, price: 135.90 }

      }
    },

    round: {

      birch: {

        "18x6":   { variantId: 51107210920169, price: 65.00 },
        "18x12":  { variantId: 51107210952937, price: 72.00 },
        "18x18":  { variantId: 51107210985705, price: 79.00 },

        "24x12":  { variantId: 51107211018473, price: 74.80 },
        "24x18":  { variantId: 51107211051241, price: 83.00 },
        "24x24":  { variantId: 51107211084009, price: 92.00 },

        "30x18":  { variantId: 51107211116777, price: 86.00 },
        "30x24":  { variantId: 51107211149545, price: 95.00 },
        "30x30":  { variantId: 51107211182313, price: 104.00 },

        "36x24":  { variantId: 51107211215081, price: 103.05 },
        "36x30":  { variantId: 51107211247849, price: 114.00 },
        "36x36":  { variantId: 51107211280617, price: 125.00 }

      },

      premium: {

        "18x6":   { variantId: 51107211313385, price: 78.56 },
        "18x12":  { variantId: 51107211346153, price: 85.56 },
        "18x18":  { variantId: 51107211378921, price: 92.56 },

        "24x12":  { variantId: 51107211411689, price: 88.36 },
        "24x18":  { variantId: 51107211444457, price: 99.20 },
        "24x24":  { variantId: 51107211477225, price: 108.20 },

        "30x18":  { variantId: 51107211509993, price: 105.80 },
        "30x24":  { variantId: 51107211542761, price: 114.80 },
        "30x30":  { variantId: 51107211575529, price: 123.80 },

        "36x24":  { variantId: 51107211608297, price: 133.56 },
        "36x30":  { variantId: 51107211641065, price: 144.90 },
        "36x36":  { variantId: 51107211673833, price: 155.90 }

      }
    },

    arch: {

      birch: {

        "18x6":   { variantId: 51107211706601, price: 72.00 },
        "18x12":  { variantId: 51107211739369, price: 79.00 },
        "18x18":  { variantId: 51107211772137, price: 86.00 },

        "24x12":  { variantId: 51107211804905, price: 81.80 },
        "24x18":  { variantId: 51107211837673, price: 90.00 },
        "24x24":  { variantId: 51107211870441, price: 99.00 },

        "30x18":  { variantId: 51107211903209, price: 93.00 },
        "30x24":  { variantId: 51107211935977, price: 102.00 },
        "30x30":  { variantId: 51107211968745, price: 111.00 },

        "36x24":  { variantId: 51107212001513, price: 110.05 },
        "36x30":  { variantId: 51107212034281, price: 121.00 },
        "36x36":  { variantId: 51107212067049, price: 132.00 }

      },

      premium: {

        "18x6":   { variantId: 51107212099817, price: 85.56 },
        "18x12":  { variantId: 51107212132585, price: 92.56 },
        "18x18":  { variantId: 51107212165353, price: 99.56 },

        "24x12":  { variantId: 51107212198121, price: 95.36 },
        "24x18":  { variantId: 51107212230889, price: 106.20 },
        "24x24":  { variantId: 51107212263657, price: 115.20 },

        "30x18":  { variantId: 51107212296425, price: 112.80 },
        "30x24":  { variantId: 51107212329193, price: 121.80 },
        "30x30":  { variantId: 51107212361961, price: 130.80 },

        "36x24":  { variantId: 51107212394729, price: 140.56 },
        "36x30":  { variantId: 51107212427497, price: 151.90 },
        "36x36":  { variantId: 51107212460265, price: 162.90 }

      }
    }
  },

  logoComplexity: {

  simple: {
    variantId: 51061740830953,
    price: 15
  },

  moderate: {
    variantId: 51061747417321,
    price: 25
  },

  advanced: {
    variantId: 51061756100841,
    price: 35
  },

  complex: {
    variantId: 51061762752745,
    price: 50
  }
  },

  textStyles: {

  flat: {

    small: {
      variantId: 51061788246249,
      price: 10
    },

    medium: {
      variantId: 51061795619049,
      price: 20
    },

    large: {
      variantId: 51061811937513,
      price: 30
    }
  },

  raised: {

    small: {
      variantId: 51061815476457,
      price: 20
    },

    medium: {
      variantId: 51061818949865,
      price: 35
    },

    large: {
      variantId: 51061821047017,
      price: 50
    }
  }
}

});


// =========================
// ADD-ON VARIANTS
// =========================

const feeVariants = Object.freeze({

  layer2: {
    variantId: 51053543817449,
    price: 25
  },

  layer3: {
    variantId: 51053545717993,
    price: 50
  },

  layer4: {
    variantId: 51053556957417,
    price: 75
  },

  rushOrder: {
    variantId: 51053548372201,
    price: 30
  },

  stainEspresso: {
    variantId: 51053559447785,
    price: 10
  },

  stainGrey: {
    variantId: 51053565280489,
    price: 12
  },

  stainBlack: {
    variantId: 51053570130153,
    price: 15
  },

  handDetail: {
    variantId: 51053592805609,
    price: 25
  },

  blackPaint: {
    variantId: 51053711229161,
    price: 15
  },

  whitePaint: {
    variantId: 51053597851881,
    price: 20
  },

  goldPaint: {
    variantId: 51053602898153,
    price: 25
  },

  standardColor: {
    variantId: 51061822030057,
    price: 15
  },

  metallic: {
    variantId: 51061824487657,
    price: 25
  },

  neon: {
    variantId: 51061826060521,
    price: 30
  },

  multiColor: {
    variantId: 51061829271785,
    price: 40
  }

});
/* =========================
   HELPERS
========================= */
function getBaseVariant(shape, wood, size) {
  return (
    variantDatabase?.baseVariants?.[shape]?.[wood]?.[size] || null
  );
}

function getTextStyleVariant(style, sizeTier) {
  return (
    variantDatabase?.textStyles?.[style]?.[sizeTier] || null
  );
}

function getLogoComplexityVariant(level) {
  return (
    variantDatabase?.logoComplexity?.[level] || null
  );
}

function getFeeVariant(key) {
  return feeVariants?.[key] || null;
}
/* =========================
   GLOBAL EXPORT
========================= */
window.WOOD_VARIANTS = Object.freeze({

  CONFIG,

  variantDatabase,

  feeVariants,

  getBaseVariant,

  getTextStyleVariant,

  getLogoComplexityVariant,

  getFeeVariant

});

console.log(
  "WOOD_VARIANTS loaded",
  window.WOOD_VARIANTS
);
